/**
 * Generates the machineNameWithCountry field by combining a machine name with a country ISO code.
 * Strips any existing country code suffix (_XX pattern) before appending the new ISO code.
 *
 * @param machineName - The machine-friendly name (e.g., "cartagena" or "cartagena_co")
 * @param countryIsoCode - The ISO code of the country (e.g., "CO", "FR")
 * @returns The combined machine name with country code (e.g., "cartagena-co")
 *
 * @example
 * ```ts
 * generateMachineNameWithCountry("cartagena", "CO") // Returns: "cartagena-co"
 * generateMachineNameWithCountry("cartagena_co", "CO") // Returns: "cartagena-co"
 * generateMachineNameWithCountry("paris_fr", "FR") // Returns: "paris-fr"
 * ```
 */
export function generateMachineNameWithCountry(machineName: string, countryIsoCode: string): string {
    // Strip existing country code suffix (_XX pattern) if present
    const baseMachineName = machineName.replace(/_[a-z]{2}$/i, "");

    // Combine base name with lowercase ISO code
    return `${baseMachineName}-${countryIsoCode.toLowerCase()}`;
}
